import React from "react";

import { Label, Typography } from "@packages/ds";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import Error from "Components/Error";
import LoginListField from "Containers/LoginListField";
import useMediaQuery from "Hooks/useMediaQuery";

import * as S from "./styles";

const EnvironmentSettingsHttpAccess = props => {
  const {
    intl,
    errors,
    basicAuth,
    ipText,
    projectId,
    environment,
    onLoginsChangeHandler,
    onLoginAddHandler,
    removeLineHandler,
    onIpTextAreaChange,
    checkLoginsValidation
  } = props;
  const onMobile = useMediaQuery("(max-width: 768px)");

  return (
    <S.HttpAccessControlInputs>
      <div className="field">
        {!onMobile && (
          <>
            <Typography.BodyText bodyTextSize="small">
              {intl.formatMessage({ id: "https_access.description" })}
            </Typography.BodyText>
          </>
        )}
        <hr />
        <LoginListField
          checkPasswordStrength={true}
          errors={errors?.original?.detail}
          basicAuth={basicAuth}
          onLoginsChangeHandler={onLoginsChangeHandler}
          onLoginAddHandler={onLoginAddHandler}
          removeLineHandler={removeLineHandler}
          projectId={projectId}
          environmentId={environment.id}
          enabled={
            environment.hasPermission && environment.hasPermission("#edit")
          }
          checkLoginsValidation={checkLoginsValidation}
        />
      </div>
      <hr />
      <div className="field">
        <Label htmlFor="ip-text-area">
          {intl.formatMessage({ id: "ip_addresses" })}
        </Label>
        <div className="access-ips">
          <S.IpTextArea
            placeholder={intl.formatMessage({
              id: "ip_addresses_description1"
            })}
            id="ip-text-area"
            name="ip-text-area"
            value={ipText}
            onChange={onIpTextAreaChange}
            disabled={
              !(environment.hasPermission && environment.hasPermission("#edit"))
            }
            aria-disabled={
              !(environment.hasPermission && environment.hasPermission("#edit"))
            }
          />
        </div>
        {!onMobile ? (
          <Typography.BodyText bodyTextSize="small">
            {intl.formatMessage({
              id: "ip_addresses_description2"
            })}{" "}
            {intl.formatMessage({ id: "for_example" })}{" "}
            <S.Code variant="inline">123.45.67.8 deny</S.Code>{" "}
            {intl.formatMessage({ id: "or" })}
            <S.Code variant="inline">123.45.67.1/32 allow</S.Code>
          </Typography.BodyText>
        ) : (
          <>
            <Typography.BodyText bodyTextSize="small">
              {intl.formatMessage({
                id: "ip_addresses_description2"
              })}{" "}
            </Typography.BodyText>
            <Typography.BodyText bodyTextSize="small">
              {intl.formatMessage({ id: "for_example" })} {onMobile && <br />}
              <S.Code variant="inline">123.45.67.8 deny</S.Code>{" "}
              {intl.formatMessage({ id: "or" })}
              <S.Code variant="inline">123.45.67.1/32 allow</S.Code>
            </Typography.BodyText>
          </>
        )}
      </div>

      {errors?.message &&
        errors?.original?.detail &&
        Object.keys(errors?.original?.detail)?.[0]?.includes("http_access") && (
          <S.ErrorWrapper>
            <Error>{errors?.message}</Error>
          </S.ErrorWrapper>
        )}
    </S.HttpAccessControlInputs>
  );
};

EnvironmentSettingsHttpAccess.propTypes = {
  intl: PropTypes.object,
  errors: PropTypes.object,
  environment: PropTypes.object,
  projectId: PropTypes.string,
  basicAuth: PropTypes.array,
  ipText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onLoginsChangeHandler: PropTypes.func,
  onLoginAddHandler: PropTypes.func,
  removeLineHandler: PropTypes.func,
  onIpTextAreaChange: PropTypes.func,
  checkLoginsValidation: PropTypes.func
};

export default injectIntl(EnvironmentSettingsHttpAccess);
